// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stream__container-e175b5 {
  min-height: var(--media-bubble-min-height);
  width: var(--message-bubble-max-width);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  background-color: var(--addition-40);
}

.Stream__image-b4c254 {
  margin: auto;
  position: relative;
  max-width: 100%;
  height: auto;
  max-height: var(--message-bubble-max-width);
  object-fit: contain;
}

.Stream__placeholder-c4c7b5 {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Stream__avatar-a15def {
  margin: 62px;
}

.Stream__live-b339dd {
  position: absolute;
  inset-inline-start: 12px;
  top: 12px;
  background-color: var(--addition-160);
  border-radius: 6px;
  padding: 6px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--addition-50);
}

.Stream__finish-e8c483 {
  position: absolute;
  inset-inline-start: 12px;
  top: 12px;
  background-color: var(--addition-110_60);
  border-radius: 6px 8px;
  padding: 6px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Stream/styles.m.css"],"names":[],"mappings":"AAAA;EACE,0CAAA;EACA,sCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,qCAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,8CAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,wCAAA;EACA,sBAAA;EACA,YAAA;EACA,4BAAA;EACA,8CAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  min-height: var(--media-bubble-min-height);\n  width: var(--message-bubble-max-width);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  background-color: var(--addition-40);\n}\n\n.image {\n  margin: auto;\n  position: relative;\n  max-width: 100%;\n  height: auto;\n  max-height: var(--message-bubble-max-width);\n  object-fit: contain;\n}\n\n.placeholder {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar {\n  margin: 62px;\n}\n\n.live {\n  position: absolute;\n  inset-inline-start: 12px;\n  top: 12px;\n  background-color: var(--addition-160);\n  border-radius: 6px;\n  padding: 6px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--addition-50);\n}\n\n.finish {\n  position: absolute;\n  inset-inline-start: 12px;\n  top: 12px;\n  background-color: var(--addition-110_60);\n  border-radius: 6px 8px;\n  padding: 6px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Stream__container-e175b5`,
	"image": `Stream__image-b4c254`,
	"placeholder": `Stream__placeholder-c4c7b5`,
	"avatar": `Stream__avatar-a15def`,
	"live": `Stream__live-b339dd`,
	"finish": `Stream__finish-e8c483`
};
module.exports = ___CSS_LOADER_EXPORT___;
